import {
  FETCH_KIOSK_SURVEYS_PENDING,
  FETCH_KIOSK_SURVEYS_SUCCESS,
  FETCH_KIOSK_SURVEYS_FAIL,
  RESET_KIOSK_SURVEYS,
  SET_KIOSK_ERROR,
  RESET_KIOSK_ERROR,
  ENABLE_KIOSK_MODE,
  DISABLE_KIOSK_MODE,
} from '../../constants/action_types';
import { services } from '../../api';
import { setLanguageISO, setLanguages } from './languages_actions';
import i18n from 'i18next';

// 1. initiate http request for kioskSurveys
// 2. store results in store
// 3. if no surveys, display feedback
// 4. if only 1 survey, immediately redirect to that survey
// 5. otherwise, let kiosk view render list of surveys for user
export const fetchKioskSurveys = (gotoSurvey, companyId, id) => async (dispatch) => {
  dispatch(fetchKioskSurveysPending());

  try {
    const surveys = await services.fetchKioskSurveys(companyId, id);

    const languagesMap = surveys.reduce((languagesMap, survey) => {
      const { languageId, langISOCode } = survey;
      languagesMap[languageId] = {
        id: languageId,
        langISOCode,
      };
      return languagesMap;
    }, {});
    const languages = Object.values(languagesMap);

    if (languages) {
      dispatch(setLanguages(languages));
    }

    dispatch(fetchKioskSurveysSuccess(id, surveys));

    if (surveys.length === 0) {
      dispatch(setKioskError(`${i18n.t('no.active.surveys.for')} '${id}'`));
    } else if (surveys.length === 1) {
      // Immediately redirect if only 1 survey.
      const survey = surveys[0];
      dispatch(resetKioskError());
      dispatch(setLanguageISO(survey.langISOCode));
      gotoSurvey(survey.surveyCode);
    }
  } catch (err) {
    let errorMessage = err.message;
    if (err.graphQLErrors) {
      errorMessage = err.graphQLErrors[0].message;
    }
    dispatch(fetchKioskSurveysFail(errorMessage));
  }
};

const fetchKioskSurveysPending = () => ({
  type: FETCH_KIOSK_SURVEYS_PENDING,
});

const fetchKioskSurveysSuccess = (uniqueId, surveys) => ({
  type: FETCH_KIOSK_SURVEYS_SUCCESS,
  uniqueId,
  surveyList: surveys.map((survey) => ({
    name: survey.name,
    surveyCode: survey.surveyCode,
    previewCode: survey.previewCode,
    companyId: survey.companyId,
    langISOCode: survey.langISOCode,
  })),
});

const fetchKioskSurveysFail = (msg) => ({
  type: FETCH_KIOSK_SURVEYS_FAIL,
  msg,
});

export const resetKioskSurveys = () => ({
  type: RESET_KIOSK_SURVEYS,
});

export const setKioskError = (msg) => ({
  type: SET_KIOSK_ERROR,
  msg,
});

export const resetKioskError = () => ({
  type: RESET_KIOSK_ERROR,
});

export const enableKioskMode = () => ({
  type: ENABLE_KIOSK_MODE,
});

export const disableKioskMode = () => ({
  type: DISABLE_KIOSK_MODE,
});
